module.exports = __webpack_public_path__ + "img/cite1.7bcdad04.png";